import { useErrandsServiceGetV1IndividualsByIndividualIdErrandsByErrandIdActions } from '../client/queries'

export const useErrandActions = (errandId?: string, individualId?: string) => {
  return useErrandsServiceGetV1IndividualsByIndividualIdErrandsByErrandIdActions(
    { errandId: errandId!, individualId: individualId! },
    undefined,
    { enabled: !!errandId && !!individualId },
  )
}
